import { Directive, HostBinding } from '@angular/core';

@Directive({
    selector: '[kui-input-group-addon]',
    standalone: false
})
export class KuiInputGroupAddonDirective {
  @HostBinding('class.input-group-text') classBinding = true;
  @HostBinding('class.input-group-addon') classBindingTwo = true; // kept for legacy reasons, a lot of styles still reference this class
}
